/**
 * Houdt een open uitklapmenu binnen de pane (ST14, #2752): MoreMenu, het ⋯-menu in de titelbalk en het
 * ⋯-menu van een snip in de viewer. Regels in menuPlacement.ts.
 */

import * as React from "react";
import { intersectX, menuMaxWidth, menuShiftX, type SpanX } from "./menuPlacement";

/** Meet het menu en zet max-width en verschuiving inline; eerst terugzetten, zodat opnieuw meten klopt. */
export function keepInPane(el: HTMLElement): void {
  el.style.transform = "";
  el.style.maxWidth = "";
  const vw = document.documentElement.clientWidth || window.innerWidth;
  let bound: SpanX = { left: 0, right: vw };
  for (let p = el.parentElement; p && p !== document.body; p = p.parentElement) {
    if (getComputedStyle(p).overflowX !== "visible") {
      const r = p.getBoundingClientRect();
      bound = intersectX(bound, { left: r.left, right: r.right });
    }
  }
  const maxWidth = menuMaxWidth(bound);
  if (el.getBoundingClientRect().width > maxWidth) el.style.maxWidth = `${maxWidth}px`;
  const r = el.getBoundingClientRect();
  const dx = menuShiftX({ left: r.left, right: r.right }, bound);
  if (dx !== 0) el.style.transform = `translateX(${dx}px)`;
}

/** Plaats het menu bij openen, bij een andere inhoud (`dep`) en bij een andere panebreedte. */
export function useKeepInPane(
  ref: React.RefObject<HTMLElement>,
  open: boolean,
  dep?: unknown
): void {
  React.useLayoutEffect(() => {
    if (!open || !ref.current) return undefined;
    const place = (): void => {
      if (ref.current) keepInPane(ref.current);
    };
    place();
    window.addEventListener("resize", place);
    return () => window.removeEventListener("resize", place);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, dep]);
}
